import {
    ADDITIONAL_PAGE_OPTIONS,
    SAILS_BNT_STORAGE,
    SAILS_PARAM_TRADE_IN,
    SalesChannel,
    SALESCHANNEL_SOHO,
} from '@vfde-sails/constants';
import { getSessionStorageItemJson } from '@vfde-sails/storage';
import { OPTION_PICKER_INPUT_CLASSNAME } from '@vfde-brix/ws10/option-picker';
import { Device } from '../interfaces/api';
import {
    APP,
    CONTAINER_TRADEIN,
    TRADEIN_OPTION_PICKER_CONTAINER_ID,
} from '../../../app/constants';
import { TRADEIN_OPTION_PICKER_VALUE_YES } from '../constants';
import { SailsDeviceDetailsStorage } from '../../../interfaces/storage';

// #region Is TradeIn

/**
 * Get trade in setting
 */
export const getTradeIn = (salesChannel: SalesChannel): boolean => {
    const storage = getSessionStorageItemJson<SailsDeviceDetailsStorage | null>(SAILS_BNT_STORAGE);

    return !!(
        getIsTradeInEligible(salesChannel)
        && storage?.[SAILS_PARAM_TRADE_IN]
        && getTradeInDeviceFromStorage()
    );
};

/**
 * Get tradeIn device from session storage
 */
export const getTradeInDeviceFromStorage = (): Device | null => {
    const storage = getSessionStorageItemJson<SailsDeviceDetailsStorage | null>(SAILS_BNT_STORAGE);

    return storage?.[APP]?.[CONTAINER_TRADEIN]?.tradeInDevice || null;
};

/**
 * Checks if tradeIn is selected
 * by checking the option-picker
 * for a checked 'yes' option.
 * Please note: Jest does not seem
 * to support the ':checked' pseudo class
 * so we are using the 'checked' DOM property
 */
export const getIsTradeInSelectedFromDom = (): boolean => {
    const yesOption = document?.querySelector(`#${TRADEIN_OPTION_PICKER_CONTAINER_ID} .${OPTION_PICKER_INPUT_CLASSNAME}[value='${TRADEIN_OPTION_PICKER_VALUE_YES}']`) as HTMLInputElement;

    return !!yesOption?.checked;
};

// #endregion

// #region Is TradeIn Eligible

/**
 * Check if trade in can be selected for this device/saleschannel
 */
export const getIsTradeInEligible = (salesChannel: SalesChannel): boolean =>
    salesChannel !== SALESCHANNEL_SOHO
        && getIsTradeInEligibleFromAdditionalPageOptions()
        && getIsTradeInEligibleFromDom()
    ;

/**
 * Check if tradein is eligible based on additional page options
 */
const getIsTradeInEligibleFromAdditionalPageOptions = (): boolean => !!window[ADDITIONAL_PAGE_OPTIONS]?.promos?.tradeIn;

/**
 * Check if tradein is eligible by checking if option picker is in the DOM
 */
const getIsTradeInEligibleFromDom = (): boolean => !!document.getElementById(TRADEIN_OPTION_PICKER_CONTAINER_ID);

// #endregion
